import { useHandler } from "@redotech/react-util/hook";
import { useRef, useState } from "react";

export interface VerticalScrollMaskResult {
  scrollRef: React.RefObject<HTMLDivElement>;
  handleScroll: () => void;
  maskImage: string | undefined;
}

export function useVerticalScrollMask(): VerticalScrollMaskResult {
  const [, setScrollTop] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScroll = useHandler(() => {
    if (scrollRef.current) {
      setScrollTop(scrollRef.current.scrollTop);
    }
  });

  const getMaskImage = (): string | undefined => {
    if (!scrollRef.current) {
      return undefined;
    }

    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    const isAtTop = scrollTop === 0;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

    if (isAtTop && isAtBottom) {
      return undefined;
    } else if (isAtTop) {
      return "linear-gradient(to bottom, black 0%, black 90%, transparent 100%)";
    } else if (isAtBottom) {
      return "linear-gradient(to bottom, transparent 0%, black 10%, black 100%)";
    } else {
      return "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)";
    }
  };

  return { scrollRef, handleScroll, maskImage: getMaskImage() };
}
